import { render, staticRenderFns } from "./view-wrapper.component.vue?vue&type=template&id=3c708cc4"
import script from "./view-wrapper.component.ts?vue&type=script&lang=ts&external"
export * from "./view-wrapper.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c708cc4')) {
      api.createRecord('3c708cc4', component.options)
    } else {
      api.reload('3c708cc4', component.options)
    }
    module.hot.accept("./view-wrapper.component.vue?vue&type=template&id=3c708cc4", function () {
      api.rerender('3c708cc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/view-wrapper/view-wrapper.component.vue"
export default component.exports